import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import Button from "./Button";

const CrossButton = ({ onClick }) => {
    return (
        <Button
                onClick={onClick}
                className="text-gray-500 hover:text-gray-700 focus:outline-none absolute top-0 right-0"
                // aria-label="Close"
            >
                <FontAwesomeIcon icon={faTimes} size="lg" />
            </Button>
    );
}

export default CrossButton;